module.exports = __webpack_public_path__ + "static/media/laying-down-lazy-relaxing-svgrepo-com.98618fef.svg";